import qs from 'qs';
import { MY_REWARDS_PAGE_URL } from '../constants/spinTheWheelConstants';
import { appInterceptor } from './appInterceptors';

export function onClickOfCloseInHeader(isAppsFlag = false) {
  isAppsFlag === 'true'
    ? appInterceptor(isAppsFlag, {
        type: 'EXIT_GAME',
        data: ''
      })
    : (window.location = '/');
}

export function onClickOfMyRewardsInHeader(isAppsFlag = false) {
  isAppsFlag === 'true'
    ? appInterceptor(isAppsFlag, {
        type: 'REDIRECT_TO_MYREWARDS_PAGE',
        data: MY_REWARDS_PAGE_URL
      })
    : (window.location = MY_REWARDS_PAGE_URL);
}

export function onClickOfRulesInHeader(showModal) {
  showModal('stw-grules-modal');
}

export function getGameTypeAndName(props) {
  const {
    location: { search: urlQueryString = '' } = {},
    match: { params: { gameType = '' } = {} } = {}
  } = props;
  const { gameName = '' } = qs.parse(urlQueryString, { ignoreQueryPrefix: true });
  return {
    gameType,
    gameName
  };
}

export function getUrlQueryString(location) {
  const { search: urlQueryString = '' } = location || {};
  let appFlag = qs.parse(urlQueryString, { ignoreQueryPrefix: true }).isAppsFlag;
  appFlag =
    typeof appFlag === 'string'
      ? appFlag
      : appFlag instanceof Array && appFlag.length
      ? appFlag[appFlag.length - 1]
      : false;

  return appFlag === 'true' ? 'true' : false;
}

export function onClickPlpLink(isAppsFlag = false, deviceType = 'desktop', data = '') {
  isAppsFlag === 'true'
    ? appInterceptor(isAppsFlag, { type: 'VIEW_APPLICABLE_PRODUCTS', data })
    : deviceType === 'desktop'
    ? window.open(data)
    : (window.location = data);
}

export function onViewAjioWallet(isAppsFlag = false, deviceType = 'desktop', data = '') {
  isAppsFlag === 'true'
    ? appInterceptor(isAppsFlag, { type: 'OPEN_AJIO_WALLET_PAGE', data })
    : deviceType === 'desktop'
    ? window.open(data)
    : (window.location = data);
}

export function onViewTnC(isAppsFlag = false, deviceType = 'desktop', data = '') {
  isAppsFlag === 'true'
    ? appInterceptor(isAppsFlag, { type: 'VIEW_TERMS_AND_CONDITIONS', data })
    : deviceType === 'desktop'
    ? window.open(data)
    : (window.location = data);
}

export function goToHomePage(isAppsFlag = false, deviceType = 'desktop', data = '') {
  isAppsFlag === 'true'
    ? appInterceptor(isAppsFlag, { type: 'OPEN_HOME_PAGE', data })
    : (window.location = data);
}
